export default "__VITE_ASSET__CJNQ2Vsy__"